/**
 * Sumber data lokasi & koordinat.
 *
 * Catatan: dataset awal (38 provinsi + ±90 kota/kabupaten + ±150 kecamatan
 * populer) di-curate manual untuk keperluan release awal. Ekspansi ke 514
 * kab/kota dan 7.277 kecamatan dilakukan bertahap dengan sumber resmi di
 * bawah ini.
 */

export interface DataSource {
  name: string;
  url: string;
  description: string;
  accessedAt: string; // ISO date
}

export const LOCATION_SOURCES: DataSource[] = [
  {
    name: "Kementerian Agama RI – Bimas Islam (SIHAT)",
    url: "https://bimasislam.kemenag.go.id/jadwalshalat",
    description:
      "Sumber utama koordinat kota/kabupaten untuk perhitungan jadwal sholat. Metode resmi: Subuh 20°, Isya 18°, Asar Syafi'i, ihtiyat 2 menit.",
    accessedAt: "2026-04-01",
  },
  {
    name: "Badan Pusat Statistik (BPS) – Kode & Nama Wilayah Administrasi Pemerintahan",
    url: "https://www.bps.go.id/id/statistics-table/wilayah",
    description:
      "Sumber kanonis 38 provinsi, 514 kabupaten/kota, dan 7.277 kecamatan se-Indonesia. Mengacu pada Permendagri No. 72/2019 dan pemekaran wilayah 2022–2024.",
    accessedAt: "2026-04-01",
  },
  {
    name: "Kementerian Dalam Negeri – Permendagri Wilayah",
    url: "https://www.kemendagri.go.id/",
    description:
      "Referensi sinkronisasi nama dan ejaan resmi wilayah, termasuk 4 provinsi pemekaran Papua (2022) dan Papua Barat Daya (2022).",
    accessedAt: "2026-04-01",
  },
  {
    name: "OpenStreetMap (OSM) Nominatim",
    url: "https://nominatim.openstreetmap.org/",
    description:
      "Centroid kecamatan untuk koordinat perhitungan ketika data koordinat resmi belum tersedia. Lisensi ODbL.",
    accessedAt: "2026-04-01",
  },
  {
    name: "praytimes.org (algoritma)",
    url: "http://praytimes.org/calculation",
    description:
      "Algoritma astronomi standar (Hamid Zarrabi-Zadeh, MIT) yang dikalibrasi ulang dengan parameter Kemenag RI. Akurasi ±1 menit terhadap jadwal SIHAT Kemenag.",
    accessedAt: "2026-04-01",
  },
];

export const LAST_UPDATED = "2026-04-01";
